export default "__VITE_ASSET__qsL8i_eW__"